<template>
  <v-container class="A4 mb-3" id="printMe">
    <v-col cols="12" sm="1" md="2" class="my-btn">
        <v-autocomplete
v-model="temp.contract_id"
          :items="contractList"
          chips
          clearable
          hide-details
          hide-selected
          item-text="name"
          item-value="id"
          label="选择户主"
          solo
          style="max-width: 600px;"
          @change="getContractById"
          :search-input.sync="searchInner"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title>
                等待加载数据中
                <strong>九色鹿网络</strong>
              </v-list-item-title>
            </v-list-item>
          </template>
          <template v-slot:selection="{ attr, on, item, selected }">
            <v-chip
              v-bind="attr"
              :input-value="selected"
              color="blue-grey"
              class="white--text"
              v-on="on"
            >
              <span v-text="item.name"></span>
            </v-chip>
          </template>
           <template v-slot:item="{ item }">
            <v-list-item-content>
              <!-- <v-list-item-title v-text="item.name"></v-list-item-title> -->
              <v-list-item-title >{{ item.name }}</v-list-item-title>
              <!-- <v-list-item-subtitle v-text="item.symbol"></v-list-item-subtitle> -->
              <v-list-item-subtitle >{{ item.symbol }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    <span v-html="styleText"></span>

    <v-row class="d-flex justify-end my-header">
      <v-btn @click="goBack" class="primary my-btn my-1">
        <i class="mdi mdi-arrow-left-bold"></i>返回
      </v-btn>
      <v-btn v-print="printObj" class="primary my-btn my-1 ml-1 mr-11">
        <i class="mdi mdi-printer"></i>打印
      </v-btn>
    </v-row>

    <h1 class="head-1" style="text-align:center;letter-spacing:40px">
      申请
    </h1>
    <v-row style="width:100%;display: inline-flex;margin-left:-5px !important;margin-top:60px">

      <v-row class="note-header " style="width:100%">
        <span style="width:100%;text-align:left;">{{company}}：</span>

      </v-row>
      <p class="note-header " style="line-height:65px">
        <span style="padding-left:2em;"></span>
        本户户主：
        <span class="data-text">{{ contract.customer }}</span>，身份证号：<span class="data-text">{{ contract.cardid }}</span>，安置房号：<span class="data-text">{{ contract.garden_name }}</span>小区
        <span class="data-text">{{contract.building_name}}</span> 幢<span class="data-text">{{contract.unit_name}}</span>单元<span class="data-text">{{contract.house_number}}</span>室，储藏室编号：
        <span class="data-text" v-if="contract.sub_name">{{contract.sub_name}}</span><span class="data-text" v-else style="width: 120px !important;"></span>，面积：<span class="data-text">{{contract.sub_area}}</span>㎡。
      </p>
      <v-row class="note-header indent" style="line-height:65px">
        安置房不动产产权人：<span class="data-text" v-if="agreement.customer">{{agreement.customer}}</span><span class="data-text" v-else style="width: 350px;"></span> ，（须提供公寓房安置买卖合同）。我户经过家庭协商，一致同意决定退还该套房子的储藏室，退还后不再要求配置其他储藏室。
      </v-row>
      <v-row class="note-header indent" style="line-height:65px">
        我户所有成员均知晓，如有其他法律等问题，一切由本户内成员自行承担。
特此申请！
      </v-row>
      <v-row class="note-header indent">
        户内人员签字：
      </v-row>
      <v-row class="note-header indent">
        不动产产权人签字：
      </v-row>
      <br>
      <br>
      
      <v-row class="note-header indent" style="width:100%">
        <span style="width:100%;text-align:right;">{{ $moment(dt_now).format("YYYY") }}年{{ $moment(dt_now).format("MM") }}月{{ $moment(dt_now).format("DD") }}日</span>

      </v-row>
    </v-row>


  </v-container>
</template>

<script>
import {fetchContractList,fetchContract} from "@/api/contracts"
import { fetchAgreement } from "@/api/agreement";

export default {
  name: "Homestead Print",
  components: {},

  filters: {},
  data() {
    return {
      searchInner:'',
      styleText: '<style type="text/css">\n' + '  @page { size: portrait; }\n' + '</style>',
      src: "hetong.png",
      seq: "",
      user_name: this.$store.getters.name,
      // company: this.$store.getters.company,
      details: null,
      // population_price: 580,
      // property_price: 960,
      // extend20_price: 3510,
      // market_discount_price: 6110,
      // market_price: 6110,
      dt_now: "",
      printObj: {
        id: "printMe",
        popTitle: "good print",
        extraCss: "https://www.baidu.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      sub_fee: 0,
      cssBackgroundImg: {
        backgroundImage: `url(${require("@/assets/background.jpg")})`
      },
      icons: {
        sub_bike: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        sub_car: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        bike: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        car: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        }

      },
      contractList:[],
      temp: {
        contract_id: "",
      },
      contract:"",
      agreement:"",
      company:"嘉善县城市建设投资集团有限公司"
    }
  },

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("admin")) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    // this.getBill(this.$route.params.id);

    // this.dt_now = Date.now();
    // this.seq = this.$route.params.seq;
    // console.log(this.$route.params.surplus)
    // this.surplus = this.numberToString(this.$route.params.seq);
    this.getContractList();
    this.dt_now = Date.now();
  },

  methods: {
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    getContractById() {
      this.getAgreement();
      this.listLoading = true;
      fetchContract(this.temp.contract_id).then(response => {
        // console.log(response.data)
        this.contract = response.data;
        if(this.contract.garden_name=="翡翠公馆"){
          this.company = "嘉善申友四达置业有限公司";
        }else if(this.contract.garden_name=="善和苑二期" || this.contract.garden_name=="善和苑2期"){
          this.company = "嘉善县城市建设投资集团有限公司";
        }else if(this.contract.garden_name=="善智苑" || this.contract.garden_name=="善智苑一期"){
          this.company = "嘉善县长城房地产有限公司";
        }
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    getAgreement(id) {
      this.listLoading = true;

      fetchAgreement(this.temp.contract_id).then(response => {
        
          this.agreement = response.data;
          
        
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    getContractList(keyword){
      const data = {
          customer_name:keyword
      }
      fetchContractList(data).then(response => {
        this.contractList = response.data.items;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      
    },
    handleInput(e) {
      console.log(e)
    },
  },
    watch: {
      searchInner (n, o) {
        // this.data.keyword = n
        console.log(this)
        this.getContractList(n)
        
        
      }
    }
};
</script>

<style scoped>
body {
  margin: auto;
  padding: auto;
  background: rgb(65, 63, 63);

}

.A4 {
  background: rgb(255, 253, 253);
  /* background-image: url(/../assets/hetong.png); */
  /* width: 21cm;
  height: 29.7cm; */
  width: 1000px;
  height: 1500px;
  display: block;
  /* box-shadow: 0 0 1px 1px rgb(2, 164, 252); */
  overflow-y: auto;
  box-sizing: border-box;
  margin: auto;
  font-family: serif;
  color: #000;
}

.head-1 {
  margin-top: 0;
  /* padding: 0 0 20px 0; */
  font-weight: 600;
  font-size: 36pt;
  text-align: center;
  width: 100%;
}

.input-text {
  font-weight: 600;
  font-size: 10pt;
  color: rgb(3, 54, 192);
}

.input-text-red {
  font-weight: 700;
  font-size: 10pt;
  color: rgb(231, 5, 5);
}

.money {
  text-align: left;
  font-weight: 600;
  color: rgb(3, 54, 192);
  padding: 0 0 0 20px;
}

td {
  padding-top: 9px;
  padding-bottom: 6px;
  padding-left: 8px;
  padding-right: 8px;
}

table {
  margin: auto;
  text-align: right;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  justify-content: space-around;
}

.note-header {
  padding: 0px 100px 30px 80px;
  font-size: 25pt;
}

.indent {
  text-indent: 2em
}

.my-input150 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 150px;
  text-align: center;
}

.line {
  line-height: 1.5;
}

.note-footer {
  padding: 20px 25px 10px 40px;
}

.data-text {
  border-bottom: 1.5px solid #555555;
  padding: 0 10px 0 10px;
  display: inline-block;
}

.my-input {
  margin: 0 35px 0 0;
}

.sanjiaoxing {
  width: 0;
  height: 0;
  border-color: transparent rgb(231, 93, 93);
  border-width: 0 0 120px 120px;
  border-style: solid;
  position: absolute;
}

.sequence {
  margin: 0 0 5px 10px;
  padding: 0 5px 0 5px;
  position: absolute;
  /* background-color: rgb(172, 104, 104); */
  transform: rotate(-45deg);
  transform-origin: 20% 40%;
}

.icon-check {
  color: #000 !important;
  margin-right: -5px;
  font-size: 12px !important;
  height: 0px;
  width: 25px;
}

.theme--dark .v-label {
  color: #000 !important;
}


@page {
  /* size: A4; */
  /* size: portrait; */
  margin: 0;
}

/* @media print{@page {size: landscape}} */

@media print {
  .A4 {
    background: white;
  }

  .head-2 {
    background-color: rgb(231, 229, 226);
  }

  .head-4 {
    background-color: rgb(231, 229, 226);
  }

  .my-header {
    height: 50px;
  }

  .my-btn {
    display: none;
  }

  .six_word {
    width: 120px;
  }

  .sanjiaoxing {
    display: none;
  }

  .sequence {
    display: none;
  }
}</style>
